import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { navigationHooks } from '../../hooks/navigationHooks/navigationHooks';
import { BackArrowLink } from '../BackArrowLink/BackArrowLink';
import { LinkIntent } from '../Link/Link';

const messages = defineMessages({
  link: {
    id: 'src.components.HomeArrowLink.link',
    defaultMessage: 'Home',
  },
});

export enum HomeRedirect {
  home = 'home',
  oldCB = 'oldCB',
}

export type Props = {
  className?: string;
  linkIntent?: LinkIntent;
  redirect?: HomeRedirect;
};

export const HomeArrowLink = React.memo((props: Props) => {
  const {
    className,
    linkIntent,
    redirect = HomeRedirect.home,
  } = props;

  const homePageRedirect = navigationHooks.useHomePageRedirect();
  const oldCBRedirect = navigationHooks.useOldCBRedirect();

  return (
    <BackArrowLink
      redirect={redirect === HomeRedirect.home
        ? homePageRedirect()
        : oldCBRedirect()
      }
      title={<FormattedMessage {...messages.link} />}
      className={className}
      linkIntent={linkIntent}
      isExternal={redirect === HomeRedirect.oldCB}
    />
  );
});

HomeArrowLink.displayName = 'HomeArrowLink';
